<template>
  <div class="empty">
    <el-image :src="webInfo.defaultFileUrl | imageUrl"/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['webInfo'])
  }
}
</script>
<style lang="scss">
.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/Empty/index.vue